import axios from 'axios';
import { api } from './api';
import { useAlertStore } from '../stores/alertStore';

export interface ReportListItem {
  id: string;
  checked: boolean;
  disabled: boolean;
  name: string;
  description: string;
  type: string;
  status: string;
  created_at: string;
  actions: string;
  template?: string;
}

export interface ReportListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: ReportListItem[];
}

export interface ReportListParams {
  page?: number;
  page_size?: number;
  type?: string;
  status?: string;
  search?: string;
  ordering?: string;
}

export const reportsService = {
  
  getReportsList: async (params?: ReportListParams): Promise<ReportListResponse> => {
    try {
      const response = await api.get('/combos/errors', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener lista de errores:', error);
      
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.error || 'Error al comunicarse con el servidor');
      }
      
      throw new Error('Error inesperado al obtener la lista de errores');
    }
  },

  processComboWithError: async (combo_ids: string[]) => {
    const { showAlert } = useAlertStore.getState();
    try {
      const response = await api.post('combos/reprocess/reprocess-batch', {
        combo_ids
      });
      showAlert({
        text: 'Procesamiento exitoso',
        message: 'Los combos seleccionados fueron reprocesados correctamente.',
        status: 'success'
      });
      return response.data;
    } catch (error) {
      console.error('Error processing combo with error:', error);
      showAlert({
        text: 'Error al reprocesar combos',
        message: 'Ocurrió un error al reprocesar los combos. Intenta nuevamente.',
        status: 'error'
      });
      throw error;
    }
  }



};
